module.exports = __webpack_public_path__ + "img/StateFair_EGM.6b5fbe50.png";